<template>
  <div id="about">
    <Title>About <LogoText /></Title>
    <p>
      <LogoText /> is a platform for players of stringed instruments, to
      socialize knowledge of the fretboard: chord voicings, scale layouts,
      arpeggios etc.
    </p>
    <p>
      Grow your collections of favourite voicings for various styles, tag them,
      group them together in progressions or songs, and share them with fellow
      musicians.
    </p>
    <SubTitle>Lessons and exercises</SubTitle>
    <p>
      Browse our collection of lessons and build yourself an exercise routine to
      keep improving your guitar skills.
    </p>
    <SubTitle>Interactive games</SubTitle>
    <p>
      Test your knowledge of the fretboard or train your ear with our
      <router-link :to="{ name: 'games' }">interactive games</router-link>!
    </p>
    <div class="game-demo">
      <h3 class="display-2">
        Example game:
      </h3>
      <QuatriadGame title="" />
    </div>
    <p class="mt-4">
      <v-btn outlined text>
        <router-link :to="{ name: 'games' }">More games</router-link>
      </v-btn>
    </p>

    <SubTitle>Fretboard diagrams</SubTitle>
    <p>
      Sleek diagrams for your guitar fingerings, and we are left-handed
      friendly!
    </p>
    <InfoQuote>
      Click on the <v-icon title="hand">mdi-hand-right</v-icon> icon on the menu
      bar to switch from right to left-handed fingerings in real time.
    </InfoQuote>
    <v-container fluid>
      <v-row>
        <v-col md="4" lg="3" v-for="(chord, i) in chords" :key="i" tabindex="0">
          <FretboardCard
            :title="chord.name"
            :notes="chord.notes"
            :frets="5"
            :startFret="chord.startFret || 0"
          />
        </v-col>
      </v-row>
    </v-container>
    <SubTitle>Scores</SubTitle>
    <p>Our lessons may include beautifully rendered scores like this one:</p>
    <Score :notes="score.notes" />
  </div>
</template>
<script>
import FretboardCard from "@/components/FretboardCard.vue";
import QuatriadGame from "@/components/QuatriadGame.vue";
import Score from "@/components/Score.vue";

export default {
  components: {
    FretboardCard,
    QuatriadGame,
    Score
  },

  data: () => ({
    chords: [
      {
        name: "C7",
        notes: "5:c3 4:e3 3:bb3 2:c4"
      },
      {
        name: "F7",
        notes: "6:f2 4:eb3 3:a3 2:c4"
      }
    ],
    score: { notes: "(C4 E4 Bb4 C5)/h, (F3 Eb4 A4 C5)/h" }
  })
};
</script>
<style scoped>
.game-demo {
  background-color: #fff8;
  border: 1px solid;
  border-color: #bbb;
  border-radius: 5px;
  padding: 1rem;
}
</style>
